module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "collaborators-success-dialog"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('div', {
    staticClass: "dflex gap-15 pt-0",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(this.type === 'album') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your album was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/album"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : (this.type === 'stream') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your video was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/video"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : (this.type === 'product') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your product was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/product/add"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "dflex gap-15 align-center"
  }, [_c('div', {
    staticClass: "dflex w-30 border-round"
  }, [(_vm.type == 'stream' || _vm.type == 'album') ? _c('img', {
    attrs: {
      "src": _vm.item.cover.url,
      "width": "100%"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.item.covers[0].cover.url,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-70"
  }, [_c('div', [_c('h3', {
    staticClass: "main-head"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('p', {
    staticClass: "second-head"
  }, [_vm._v(_vm._s(_vm.type == 'product' ? _vm.item.merchant.username : _vm.item.user.username))]), _vm._v(" "), (_vm.type === 'album') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.item.tracks.length) + " tracks")]) : _vm._e(), _vm._v(" "), (_vm.type !== 'product') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.type === 'album' ? _vm.item.genres[0] && _vm.item.genres[0].name : _vm.item.genre.name))]) : _vm._e(), _vm._v(" "), (_vm.type == 'product') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.item.category.name))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "dflex align-center gap-20"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/email-xcon.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/facebook-xcon.svg"),
      "width": "10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/twitter-xcon.svg"),
      "width": "17"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "url-bar"
  }, [_c('p', {
    staticClass: "mx-0 my-0"
  }, [_vm._v(_vm._s(_vm.albumURL))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.albumURL),
      expression: "albumURL",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "clipboard-btn"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/clone.svg"),
      "width": "16"
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f545df6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/albumfinishmodal.vue
// module id = 1872
// module chunks = 180